module.exports = __webpack_public_path__ + "static/media/PSLDisplayPro.aab35a3a.eot";